import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../_App/Redux/hooks";
import { useParams } from "react-router-dom";
import {
  appliquerRemiseConditionApi,
  getRemiseConditionsApi,
  updateRemiseApi,
} from "../../../../_App/Redux/Slices/remise/remiseSlice";
import { useTranslation } from "react-i18next";
import RemiseV2Page from "./RemiseV2Page";
import Select from "react-select";
import {
  allOrganisationsApi,
  ListOrganisations,
} from "../../../../_App/Redux/Slices/organisations/organisationSlice";
import { handleKeyPress_number } from "../../../../_App/Helpers/helpers";
import { ToastSuccess } from "../../../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../../../Shared/Toasts/ToastWarning";
import { societeId } from "../../../../_App/Redux/Slices/Auth/authSlice";
import Swal from "sweetalert2";

export default function ConditionRemise() {
  let { id } = useParams();
  const { t } = useTranslation();
  const listOrganisation = useAppSelector(ListOrganisations);
  const optionsOrganisation: any = listOrganisation.map((item: any) => ({
    value: item._id.toString(),
    label: item.nom,
  }));
  const societe = useAppSelector(societeId);

  useEffect(() => {
    if (societe) {
      dispatch(allOrganisationsApi(societe));
    }
  }, [societe]);

  const handleOrgChange = (newValue: any) => {
    setselectedOrg(newValue);
  };
  const [modifierRemise, setModifierRemise] = useState(false);
  const [selectedOrg, setselectedOrg] = useState([]);

  const dispatch = useAppDispatch();
  const [listCondition, setListCondition] = useState([]);
  const [remise, setRemise] = useState<any>();
  const [Addcondition, setAddcondition] = useState<any>();
  const [newRemiseData, setNewRemiseData] = useState<any>();

  const findConditionProduit = async (id: any) => {
    const response: any = await dispatch(getRemiseConditionsApi(id));
    if (response.payload.status === 200) {
      setListCondition(response.payload.data.condition);

      setRemise(response.payload.data.remise);

      setNewRemiseData({
        conditions: response.payload.data?.remise?.conditions,
        percentage: response.payload.data?.remise?.percentage,
        libelle: response.payload.data?.remise?.libelle,
      });
      setselectedOrg(
        response.payload.data.remise.organisation_id.map((org: any) => ({
          value: org._id?.toString(),
          label: org.nom,
        })),
      );
    }
  };
  useEffect(() => {
    findConditionProduit(id);
  }, [id]);

  const updateRemiseData = async () => {
    const newObj = {
      ...newRemiseData,
      organisation_id: selectedOrg.map((o: any) => o.value),
      _id: id,
    };
    const obj = {
      remise: newObj,
    };
    const response = await dispatch(updateRemiseApi(obj));
    if (response) {
      if (response.payload?.success) {
        ToastSuccess(t(response.payload.message));
        setRemise(response.payload.data.updateremise);
        setModifierRemise(false);
      } else {
        ToastWarning(t(response.payload.message));
      }
    }
  };
  const appliquerRemise = async (condi: any) => {
    const data = { idremise: id, condiId: condi };
    const resp = await dispatch(appliquerRemiseConditionApi(data));
    if (resp.payload.success) {
      ToastSuccess(resp.payload.message);
      window.location.reload();
    }
  };

  const showArticles = (articlesList:any) => {
    const htmlList = articlesList
      .map(
        (item: any) =>
          `<div style="margin-bottom:5px;"><strong>${item.titre.fr}</strong> </div>`,
      )
      .join("");

    Swal.fire({
      title: "Liste des articles",
      html: htmlList,
      width: "700px",
      confirmButtonText: "Fermer",
    });
  };

  return (
    <div>
      {modifierRemise ? (
        <div className="  bg-white" style={{ color: "black", padding: "10px" }}>
          <div className="row ">
            <div className="col-3">
              <strong>{t("Libelle : ")}</strong>
              <input
                type="text"
                className="form-control"
                value={newRemiseData?.libelle}
                onChange={(e) =>
                  setNewRemiseData((prev: any) => ({
                    ...prev,
                    libelle: e.target.value,
                  }))
                }
              />
            </div>
            <div className="col-2">
              <strong>{t("Pourcentage : ")}</strong>{" "}
              <input
                type="text"
                className="form-control"
                value={newRemiseData?.percentage}
                onChange={(e) =>
                  setNewRemiseData((prev: any) => ({
                    ...prev,
                    percentage: parseFloat(e.target.value),
                  }))
                }
                onKeyPress={handleKeyPress_number}
              />
            </div>
            <div className="col-2">
              <strong>{t("Magasin : ")}</strong>{" "}
              <span>
                <Select
                  isMulti
                  options={optionsOrganisation}
                  value={selectedOrg}
                  onChange={handleOrgChange}
                  placeholder="Sélectionner magasin"
                />
              </span>
            </div>

            <div className="col-1">
              <button
                className="btn btn-success mt-2"
                onClick={() => setModifierRemise(false)}
              >
                {t("Annuler")}
              </button>
            </div>
            <div className="col-1">
              <button className="btn btn-primary" onClick={updateRemiseData}>
                {t("Enregistrer modification")}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="  bg-white" style={{ color: "black", padding: "10px" }}>
          <div className="row ">
            <div className="col-3">
              <strong>{t("Libelle : ")}</strong> <span> {remise?.libelle}</span>
            </div>
            <div className="col-2">
              <strong>{t("Pourcentage : ")}</strong>{" "}
              <span> {remise?.percentage}</span>
            </div>
            <div className="col-3">
              <strong>{t("Magasin : ")}</strong>{" "}
              <span>
                {" "}
                {remise?.organisation_id?.length === 0
                  ? "Tous les magasins"
                  : remise?.organisation_id.map((org: any) => org.nom)}
              </span>
            </div>

            <div className="col-2">
              <button
                className="btn btn-primary"
                onClick={() => setModifierRemise(true)}
              >
                {t("Modifier")}
              </button>
            </div>
            {listCondition.filter((c: any) => c.app).length === 1 ? (
              <div className="col-2">
                <button
                  className="btn btn-primary"
                  onClick={() => appliquerRemise(undefined)}
                >
                  {t("Appliquer remise sur tout les condition")}
                </button>
              </div>
            ) : (
              <div className="col-2">
                {t("Remise Appliquesur tout les condition")}
              </div>
            )}
          </div>
        </div>
      )}

      <div className="  bg-white" style={{ marginTop: "5px", padding: "10px" }}>
        <div className="table-responsive">
          <table className="table">
            <thead>
              {" "}
              <tr>
                <th>{t("groupe")}</th>
                <th>{t("Famille")}</th>
                <th>{t("Produit ")}</th>
                <th>{t("Type ")}</th>
                <th>{t("qte min")}</th>
                <th>{t("qte max")}</th>
                <th>{t("")}</th>
              </tr>
            </thead>
            <tbody>
              {listCondition &&
                listCondition.map((item: any, indexitem) =>
                  item?.sous_categorie_id?.length > 0 ? (
                    item.sous_categorie_id.map((sc: any, indexsc: any) => (
                      <tr key={`${indexitem}-${indexsc}`}>
                        <td style={{ fontSize: "16px", fontWeight: "bolder" }} onClick={()=>showArticles(item.groupe_id.list_article)}>
                          <p className="lien-bleu-souligne">
                            {" "}
                            {item?.groupe_id?.libelle}
                          </p>
                        </td>

                        <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                          {sc?.libelle?.fr}
                        </td>

                        <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                          {item?.article_id?.titre?.fr}
                        </td>
                        <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                          {item?.type}
                        </td>

                        <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                          {item?.min}
                        </td>

                        <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                          {item?.max}
                        </td>
                        <td>
                          {item.app ? (
                            "remise applique sur cette condition"
                          ) : (
                            <button
                              className="btn btn-primary"
                              onClick={() => appliquerRemise(item._id)}
                            >
                              {t("Appliquer remise sur cette  condition")}
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr key={indexitem}>
                      <td style={{ fontSize: "16px", fontWeight: "bolder" }} onClick={()=>showArticles(item.groupe_id.list_article)}>
                        <p className="lien-bleu-souligne">
                          {" "}
                          {item?.groupe_id?.libelle}
                        </p>
                      </td>
                      <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                        {" "}
                        -
                      </td>
                      <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                        {item?.article_id?.titre?.fr}
                      </td>
                      <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                        {item?.type}
                      </td>

                      <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                        {item?.min}
                      </td>
                      <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                        {item?.max}
                      </td>
                      <td>
                        {item.app ? (
                          "remise applique sur cette condition"
                        ) : (
                          <button
                            className="btn btn-primary"
                            onClick={() => appliquerRemise(item._id)}
                          >
                            {t("Appliquer remise sur cette  condition")}
                          </button>
                        )}
                      </td>
                    </tr>
                  ),
                )}
            </tbody>
          </table>
          <button
            className="btn btn-primary"
            onClick={() => setAddcondition(true)}
          >
            {" "}
            {t("Ajouter condition")}
          </button>
        </div>
      </div>
      {Addcondition && (
        <div
          className="  bg-white"
          style={{ marginTop: "15px", padding: "10px" }}
        >
          <RemiseV2Page remise_id={id} setListCondition={setListCondition} />
        </div>
      )}
    </div>
  );
}
